// PAQUETES
import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
// estilos
import '../../../estilos/reserva.css';
// componentes
import ZonaCargando from '../../alertas/zonaCargando';
// funciones
import { formatearMoneda } from "../../../funcionesDatos/Moneda";
import { pixelCompraCompletada, pixelPrimeraCompraDescuento } from "../../../funcionesDatos/pixelFacebook";
import { gtagCompraCompletada } from "../../../funcionesDatos/pixelGoogle";
import { ttqCompraCompletada, ttqPrimeraCompraDescuento } from "../../../funcionesDatos/pixelTiktok";
import { eventoCompraCompletada } from "../../../funcionesDatos/eventoPropio";

function RespuestaPago(){

    const navigate = useNavigate();

    // ttps://app-desarrollo-f097d421d3f0.herokuapp.com/respuesta-pago/?id=12041751-1773615570-58993&env=test 
    const [searchParams] = useSearchParams();

    const idTransaccion = searchParams.get('id'); // id de wompi, no de mi base de datos. 
    const env = searchParams.get("env"); // test


    const { usuario, cargandoUsuario } = useOutletContext() || {};
    const [cargando, setCargando]      = useState(false);
    const cargandoFinal                = Boolean(cargandoUsuario) || Boolean(cargando);

    const [reserva, setReserva]                = useState(null);
    const [transaccion, setTransaccion]        = useState(null);
    const [verificandoPago, setVerificandoPago] = useState(true);

    const estadoPago = (transaccion?.status || "NA").toString().trim().toUpperCase();
    const estadoPagoTexto =
        estadoPago === "APPROVED" ? "Aprobado"
        : estadoPago === "PENDING" ? "Pendiente"
        : estadoPago === "DECLINED" ? "Rechazado"
        : estadoPago === "ERROR" ? "Error"
        : estadoPago === "VOIDED" ? "Anulado"
        : "Sin estado";

    const esAprobado      = estadoPago === "APPROVED";
    const esPendiente     = estadoPago === "PENDING";
    const montoFormateado = formatearMoneda((Number(transaccion?.amount_in_cents || 0)) / 100);
    const mensajeEstado   = (reserva?.cobro?.mensajeEstado || "").toString().trim();

    const metodoPagoTipo  = (reserva?.cobro?.metodoPagoTipo || "NA").toString().trim();
    const metodoPagoExtra1 = (reserva?.cobro?.metodoPagoExtra1 || "NA").toString().trim();
    const metodoPagoExtra2 = (reserva?.cobro?.metodoPagoExtra2 || "NA").toString().trim();

    const formatearFechaPago = (fecha) => {
        const texto = (fecha || "").toString().trim();
        if (!texto || texto === "NA" || texto === "null") return "NA";
        try {
            const dt = new Date(texto);
            if (Number.isNaN(dt.getTime())) return texto;
            return new Intl.DateTimeFormat('es-CO', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            }).format(dt);
        } catch (_) {
            return texto;
        }
    };

    const fechaPago = formatearFechaPago(reserva?.cobro?.fechaPago);





    useEffect(() => {
        let intervalo = null;
        let cancelado = false;

        const consultarTransaccion = async () => {
            try {
                // 1) Esperar a que Direccionamiento termine de verificar token
                if (cargandoUsuario) return;

                // 2) Si NO hay usuario, redirigir SOLO una vez a iniciar sesión
                if (!usuario) {
                    Swal.fire({
                        icon: "error",
                        title: "Inicia sesión",
                        text: "Debes iniciar sesión para completar la compra",
                        confirmButtonText: "Continuar",
                        customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate("/iniciar-sesion");
                        }
                    });
                    return;
                }

                if (!idTransaccion) { setVerificandoPago(false); return; }

                setCargando(true);



                const resPago = await axios.post("/obtener-datos-transaccion", {
                    params: { idTransaccion }
                });

                if (cancelado) return;

                const data = resPago?.data || {};
                const transaccionEncontrada = data?.transaccion || null;
                const reservaEncontrada = data?.reserva || null;
                const tieneTransaccion = Boolean(data?.tieneTransaccion);

                setReserva(reservaEncontrada);

                if (tieneTransaccion && transaccionEncontrada) {
                    setTransaccion(transaccionEncontrada);

                    // CREAMOS EL EVENTO DE COMPRA PIXEL FACEBOOK SOLO SI EL EVENTO DE COMPRA FUE EXITOSO
                    const estadoFinal = (transaccionEncontrada.status || "").toUpperCase();
                    if (estadoFinal === "APPROVED") {
                        // `cobro.descuentoPrimeraCompraAplicado` nunca se persiste en el modelo Reserva
                        // (solo existe como valor efímero dentro de calcularDesgloseCobro) — se deriva del
                        // monto guardado para no dejar los eventos de descuento permanentemente apagados.
                        const montoDescuento    = Number(reservaEncontrada?.cobro?.descuentoPrimeraCompra || 0);
                        const descuentoAplicado = montoDescuento > 0;

                        pixelCompraCompletada({
                            transaccionId: transaccionEncontrada.id,
                            monto:         (Number(transaccionEncontrada.amount_in_cents || 0)) / 100,
                            moneda:        transaccionEncontrada.currency || "COP",
                        });
                        if (descuentoAplicado) {
                            pixelPrimeraCompraDescuento({ transaccionId: transaccionEncontrada.id, montoDescuento });
                        }
                        gtagCompraCompletada({
                            transaccionId: transaccionEncontrada.id,
                            monto:         (Number(transaccionEncontrada.amount_in_cents || 0)) / 100,
                            moneda:        transaccionEncontrada.currency || "COP",
                            descuentoAplicado,
                        });
                        ttqCompraCompletada({
                            transaccionId: transaccionEncontrada.id,
                            monto:         (Number(transaccionEncontrada.amount_in_cents || 0)) / 100,
                            moneda:        transaccionEncontrada.currency || "COP",
                        });
                        if (descuentoAplicado) {
                            ttqPrimeraCompraDescuento({ transaccionId: transaccionEncontrada.id, montoDescuento });
                        }
                        eventoCompraCompletada({
                            transaccionId: transaccionEncontrada.id,
                            monto:         (Number(transaccionEncontrada.amount_in_cents || 0)) / 100,
                            usuarioId:     usuario?.idUsuario,
                            descuentoPrimeraCompraAplicado: descuentoAplicado,
                            descuentoPrimeraCompra:         montoDescuento,
                        });
                    }



                    setVerificandoPago(false);

                    if (intervalo) {
                        clearInterval(intervalo);
                        intervalo = null;
                    }
                } 
                else {
                    setTransaccion(null);
                    setVerificandoPago(true);
                }
            }
            catch (err) { console.log("Error en respuesta pago:", err); }
            finally { if (!cancelado) { setCargando(false); } }
        };

        consultarTransaccion();

        if (!intervalo) {
            intervalo = setInterval(() => {
                consultarTransaccion();
            }, 10000); // cada 10 segundos
        }

        return () => {
            cancelado = true;
            if (intervalo) clearInterval(intervalo);
        };
    }, [cargandoUsuario, usuario, navigate, idTransaccion, env]);
   
   
  












    return(
    <div>
    { cargandoFinal ? <ZonaCargando />
    : <div className="container py-5" style={{ minHeight: "55vh" }}>
        <div className="mx-auto" style={{ maxWidth: 860 }}>
            {verificandoPago ? <div>
            <div className="text-center mb-4">
                <div className="text-uppercase text-body-secondary small fw-semibold mb-2">Pago en proceso</div>
                <h1 className="mb-2">Verificando tu pago</h1>
                <p className="text-body-secondary mb-0">Estamos esperando la confirmación final de la transacción.</p>
            </div>
            <div className="card border-0 shadow-sm">
                <div className="card-body p-4 p-md-5 text-center">
                    <div className="spinner-border mb-3" aria-hidden="true"></div>
                    <div className="fw-bold fs-5 mb-2">Estamos verificando el estado de tu pago</div>
                    <div className="mb-2 text-body-secondary mx-auto" style={{ maxWidth: 620 }}>
                        Esto normalmente tarda unos segundos. En algunos casos la confirmación puede demorar un poco más.
                    </div>
                    <div className="small text-body-secondary mx-auto" style={{ maxWidth: 620 }}>
                        Si cierras esta página, luego podrás revisar el resultado en tus reservas o en tu cuenta.
                    </div>
                </div>
            </div>
            </div>
            : transaccion ? <div>
            <div className="text-center mb-4">
                <div className={`badge rounded-pill px-3 py-2 mb-3 ${esAprobado ? "text-bg-success" : esPendiente ? "text-bg-warning" : "text-bg-danger"}`}>
                    {estadoPagoTexto}
                </div>
                <h1 className="mb-2">{esAprobado ? "Gracias por tu reserva" : esPendiente ? "Tu reserva sigue en verificación" : "No pudimos confirmar tu reserva"}</h1>
                <p className="text-body-secondary mb-0">
                    {esAprobado
                        ? "Hemos recibido la confirmación de tu reserva."
                        : esPendiente
                            ? "Tu reserva fue creada, pero aún no recibimos una confirmación final del pago."
                            : (mensajeEstado || "No pudimos confirmar el pago de tu reserva. Puedes revisar el detalle e intentarlo nuevamente si lo necesitas.")}
                </p>
                {esAprobado ? 
                <div className="alert alert-success border-0 shadow-sm mt-3 mb-0 text-start" role="alert">
                    <div className="fw-semibold mb-1">Gracias por confiar en Zervicy.</div>
                    <div>Con tu reserva también apoyas a personas que trabajan de forma independiente.</div>
                </div>
                : null}
                {!esAprobado && mensajeEstado ? 
                <div className="alert alert-warning border-0 shadow-sm mt-3 mb-0 text-start" role="alert">
                    <div className="fw-semibold mb-1">Detalle del estado</div>
                    <div>{mensajeEstado}</div>
                </div>
                : null}
            </div>

            <div className="card shadow-sm border-0">
                <div className="card-body p-4 p-md-5">
                    <div className="row g-3">
                        <div className="col-12 col-md-6">
                            <div className="text-body-secondary small mb-1">ID transacción</div>
                            <div className="fw-semibold text-break">{transaccion?.id || 'NA'}</div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="text-body-secondary small mb-1">Referencia</div>
                            <div className="fw-semibold text-break">{transaccion?.reference || 'NA'}</div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="text-body-secondary small mb-1">Estado</div>
                            <div className="fw-semibold">{estadoPagoTexto}</div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="text-body-secondary small mb-1">Monto</div>
                            <div className="fw-semibold">{montoFormateado}</div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="text-body-secondary small mb-1">Moneda</div>
                            <div className="fw-semibold">{transaccion?.currency || 'NA'}</div>
                        </div>
                        {fechaPago !== 'NA' ? (
                        <div className="col-12 col-md-6">
                            <div className="text-body-secondary small mb-1">Fecha de pago</div>
                            <div className="fw-semibold">{fechaPago}</div>
                        </div>
                        ) : null}

                        {metodoPagoTipo !== 'NA' ? (
                        <div className="col-12 col-md-6">
                            <div className="text-body-secondary small mb-1">Método de pago</div>
                            <div className="fw-semibold text-capitalize">{metodoPagoTipo}</div>
                        </div>
                        ) : null}

                        {metodoPagoExtra1 !== 'NA' ? (
                        <div className="col-12 col-md-6">
                            <div className="text-body-secondary small mb-1">Detalle 1</div>
                            <div className="fw-semibold text-capitalize">{metodoPagoExtra1}</div>
                        </div>
                        ) : null}

                        {metodoPagoExtra2 !== 'NA' ? (
                        <div className="col-12 col-md-6">
                            <div className="text-body-secondary small mb-1">Detalle 2</div>
                            <div className="fw-semibold">{metodoPagoExtra2}</div>
                        </div>
                        ) : null}
                    </div>
                </div>
            </div>

            <div className="d-grid gap-2 mt-4">
                <button className="btn btn-primary btn-lg d-flex align-items-center justify-content-center gap-2" onClick={() => navigate("/usuario/reservas")}> 
                    <i className="bi bi-calendar-check"></i>
                    <span>Ir a mis reservas</span>
                </button>
                <button className="btn btn-outline-secondary d-flex align-items-center justify-content-center gap-2" onClick={() => navigate("/vendedor")}>
                    <i className="bi bi-person-circle"></i>
                    <span>Ir a mi cuenta</span>
                </button>
            </div>
            </div>
            : 
            <div>
                <div className="text-center mb-4">
                    <div className="text-uppercase text-body-secondary small fw-semibold mb-2">Pago sin confirmación</div>
                    <h1 className="mb-2">Aún no recibimos una respuesta final</h1>
                    <p className="text-body-secondary mb-0">Puedes esperar un momento más o revisar luego el estado en tus reservas.</p>
                </div>
                <div className="alert alert-warning border-0 shadow-sm p-4 text-center" role="alert">
                    Tu transacción todavía no tiene una confirmación definitiva. En algunos casos este proceso puede tardar algunos minutos.
                </div>
                <div className="d-grid mt-4">
                    <button className="btn btn-outline-secondary d-flex align-items-center justify-content-center gap-2" onClick={() => navigate("/usuario/reservas")}>
                        <i className="bi bi-calendar-check"></i>
                        <span>Ver mis reservas</span>
                    </button>
                </div>
            </div>}
        </div>
    </div>
    }
    </div>
    )
}

export default RespuestaPago;